import { Icon } from "@opendash/icons";
import { Button } from "antd";
import * as React from "react";
import { $framework, useElementSize, useOpenDashApp, useTranslation, } from "../..";
import { NotificationDialog } from "../../features/notifications";
import * as Layout from "./components";
import { GlobalStyle } from "./GlobalStyle";
import { HeaderNavigation } from "./HeaderNavigation";
import { HeaderSourcePicker } from "./HeaderSourcePicker";
import { LanguageDialog } from "./LanguageDialog";
import { UserPasswordChange } from "./UserPasswordChange";
import { VersionDialog } from "./VersionDialog";
export default function AppLayout({ children }) {
    const t = useTranslation();
    const app = useOpenDashApp();
    const headerRef = React.useRef();
    const headerSize = useElementSize(headerRef);
    React.useEffect(() => {
        app.ui2.setHeaderSize(headerSize.height, headerSize.width);
    }, [headerSize.height, headerSize.width]);
    return (React.createElement(React.Fragment, null,
        React.createElement(GlobalStyle, null),
        React.createElement(LanguageDialog, null),
        React.createElement(NotificationDialog, null),
        React.createElement(UserPasswordChange, null),
        React.createElement(VersionDialog, null),
        !app.ui.disableHeader && (React.createElement(Layout.Header, { id: "opendash-header", ref: headerRef },
            React.createElement(HeaderNavigation, null),
            React.createElement(HeaderSourcePicker, { mobile: true }))),
        React.createElement(Layout.Layout, { id: "opendash-layout", ref: app._refs.layout },
            React.createElement(Layout.Content, { id: "opendash-content" },
                React.createElement("div", { id: "opendash-ref-content", ref: app._refs.content, style: { width: "100vw" } }),
                children),
            !app.ui.disableFooter && (React.createElement(Layout.Footer, { id: "opendash-footer" },
                React.createElement("div", { id: "opendash-ref-footer", ref: app._refs.footer }),
                React.createElement(Layout.FooterRowCopyright, null,
                    ($framework.ui2.copyrightText || null) && (React.createElement(Button, { type: "link", href: $framework.ui2.copyrightLink, target: "_blank", children: $framework.ui2.copyrightText })),
                    ($framework.ui2.imprint || null) && (React.createElement(Button, { type: "link", href: $framework.ui2.imprint, target: "_blank", children: t("opendash:ui.imprint") })),
                    ($framework.ui2.tos || null) && (React.createElement(Button, { type: "link", href: $framework.ui2.tos, target: "_blank", children: t("opendash:ui.tos") })),
                    ($framework.ui2.dataProtection || null) && (React.createElement(Button, { type: "link", href: $framework.ui2.dataProtection, target: "_blank", children: t("opendash:ui.data_protection") })),
                    React.createElement(Button, { type: "text", children: app.ui2.version, onClick: () => app.ui2.showVersionDialog() }),
                    ($framework.serviceWorker.updateAvailable || null) && (React.createElement(Button, { type: "text", onClick: () => $framework.serviceWorker.installUpdateDialog(), children: React.createElement(Icon, { icon: "fa:sync-alt", color: "#52C41A" }) }))),
                React.createElement("div", { id: "opendash-ref-footer-after-copyright", ref: app._refs.footerAfterCopyright }))))));
}
//# sourceMappingURL=index.js.map